import dayjs from "dayjs";

export function todayInSydney() {
  return dayjs(new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" }));
}
